import React from 'react';
import PricingService from './PricingService';
import GeoService from './GeoService';
import QuoteService from './QuoteService';

type GlobalServicesProps = { children: React.ReactNode };

function GlobalServices({ children }: GlobalServicesProps) {
  return (
    <QuoteService>
      <PricingService>
        <GeoService>{children}</GeoService>
      </PricingService>
    </QuoteService>
  );
}

export default GlobalServices;
